import { makeVar, type ReactiveVar } from '@apollo/client';
import { DEFAULT_SIZE, VISUAL_MODE } from 'src/constants';
import type { ViewState } from 'src/types/store.types';

export const initialViewState: ViewState = {
  opensearchData: [],
  collectionData: [],
  mediaCardPreviewIndex: undefined,
  largeVideoPreviewIndex: undefined,
  mediaCardMediaPageIndex: undefined,
  collectionPreviewIndex: undefined,
  globalAction: null,
  playlistItemMediaPageIndex: undefined,
  mediaPageViaLibrary: true,
  mediaPageViaPlaylist: false,
  signedInUserRole: '',
  collectionId: null,
  selectedCollectionId: null,
  selectedCollectionName: null,
  selectedItemId: null,
  showMetadata: false,
  showLeftSidebar: false,
  showRightSidebar: false,
  leftDrawerWidth: 240,
  rightDrawerWidth: 20,
  defaultRightDrawerWidth: 320,
  minRightDrawerWidth: 20,
  maxRightDrawerWidth: 480,
  openNewCollection: false,
  openEditCollection: false,
  openMyCollection: true,
  previewModal: false,
  previewModalVideo: null,
  previewModalThumbnailId: '',
  previewModalProxyId: '',
  editFieldDefModal: false,
  editFieldDefId: '',
  editFieldMapsId: '',
  editFieldMapsName: '',
  isSelectAll: false,
  showHorizontal: false,
  openDatePicker: false,
  regularStartDate: '',
  regularEndDate: '',
  ISOStartDate: '',
  ISOEndDate: '',
  searchTerm: '',
  horizontalMediaCardDetails: { image: '', title: '' },
  akomiMediaCard: [],
  selectedAssets: [],
  selectedFieldMapsForDelete: [],
  horizontalMediaCardIndex: 0,
  showGalleryPageLightBox: false,
  renamePlaylist: null,
  editClip: null,
  shareDialog: null,
  shareContent: null,
  deleteDialog: null,
  fieldDefDeleteDialog: null,
  fieldMapsDeleteDialog: null,
  deleteFieldDefId: '',
  deleteFieldDefName: '',
  deleteFieldMapsConfigId: '',
  deleteFieldMapsConfigName: '',
  usersDeleteDialog: null,
  selectedDeleteUsername: '',
  selectedRowsUserIds: [],
  selectedRowsUsernames: [],
  hiresDialog: null,
  filterChips: [],
  filterCategoryExclude: [],
  libraryDownloadDialog: null,
  sharedItemDownloadDialog: null,
  sharedCollectionDownloadDialog: null,
  sharedCollectionId: null,
  downloadMarkerDialog: { markerId: '', assetId: '' },
  sortData: {
    sortBy: { value: '', fieldType: '' },
    orderBy: 'desc',
    field: null,
  },
  filter: {
    category: { id: '', name: '', label: '' },
    choices: [],
  },
  pagination: {
    cursor: null,
    page: 1,
    numberOfPages: null,
    perPage: DEFAULT_SIZE,
    totalCount: 0,
  },
  viewModels: {
    library: {
      ViewMediaCardListView: null,
      ViewFilterBarFirstDropdown: null,
      ViewMediaCardShowMetadata: null,
      ViewMediaCardInfo: null,
      ViewMediaCardHorizontalInfo: null,
      ViewMediaCardHorizontalDetails: null,
      ViewTechPanel: null,
      ViewMediaCardInline: null,
      ViewMediaCardMinimalInfo: null,
    },
    gallery: {
      ViewGalleryCardMeta: null,
      ViewGalleryPage: null,
    },
  },
  showNewCollectionDialog: false,
  playingVideoId: null,
  mode: VISUAL_MODE,
  isGalleryPanelOpen: true,
  isGalleryPanelEditing: false,
};

const viewStateVar: ReactiveVar<ViewState> = makeVar<ViewState>(initialViewState);

export default viewStateVar;
